const i = "通知", t = "重要通知", o = "关闭通知", c = {
  notification: i,
  criticalNotification: t,
  close: o
};
export {
  o as close,
  t as criticalNotification,
  c as default,
  i as notification
};
